module.exports = __webpack_public_path__ + "media/site_templates/www.lawnmowingservices.me/images/about_us-966dfbce21f5f2f705114c64a96630c0.jpg";